import { render, staticRenderFns } from "./LedgerBankImportModal.vue?vue&type=template&id=6b22138e&"
import script from "./LedgerBankImportModal.vue?vue&type=script&lang=js&"
export * from "./LedgerBankImportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports